import type { ActType, EventType } from '../types/marketplace';

export const genres = [
  'T-Pop',
  'Luk Thung',
  'Soul',
  'R&B',
  'Jazz',
  'Pop',
  'Rock',
  'Indie',
  'Funk',
  'Disco',
  'Acoustic',
  'Folk',
  'Gospel',
  'Electronic',
];

export const eventTypes: EventType[] = [
  'Wedding',
  'Club night',
  'Festival',
  'Corporate',
  'Private party',
  'Bar gig',
];

export const actTypes: ActType[] = ['Solo singer', 'Duo', 'Band'];

export const weekDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const themes = [
  'Golden hour soul',
  'Black tie',
  'Garden party',
  'Retro disco',
  'Speakeasy',
  'Summer festival',
];
